<!-- 可新增/删除table表格页面 -->
<template>
  <div>
    <el-button type="success" icon="el-icon-plus" size="mini" @click="handleAddBtn">添加</el-button>
    <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDeleteBtn">删除</el-button>
    
    <el-table
      :data="goodsList"
      style="width: 100%">
      <el-table-column label="选择" align="center" width="65">
        <template slot-scope="scope">
        <el-radio :label="scope.$index" v-model="ProductRadio"
       >&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        prop="salePrice"
        label="销售价格"
        width="180">
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="生效日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop=""
        label="支付凭证"
        width="180">
      </el-table-column>
      <el-table-column
        prop=""
        label="投保单号"
        width="180">
      </el-table-column>
      <el-table-column
        prop=""
        label="保单号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="price"
        label="净费"
        width="180">
      </el-table-column>
      <el-table-column
        prop="real_price"
        label="保费"
        width="180">
      </el-table-column>
      <el-table-column
        prop="profit"
        label="毛利润"
        width="180">
      </el-table-column>

      <el-table-column
        prop="commission"
        label="绩效"
        width="180">
      </el-table-column>
    </el-table>
    

   
    <!-- 险种方案选择弹框 -->
    <el-dialog title="险种方案选择" :visible.sync="insuranceSchemeDialog" width="850px">
        <!-- 搜索 -->
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form
                :inline="true"
                :model="isTableSearchForm"
                :rules="isTableSearchRules"
                ref="isSearchForRef"
                label-width="100px"
                autocomplete="on"
              >
              <el-form-item>
                <el-input v-model="isTableSearchForm.productName" placeholder="产品名称/保司名称" type="text" name="productName"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="1">
            <el-button type="success" @click="isSearchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
        </el-row>
        <!-- 表格 -->
        <el-table
          ref="multipleTable"
          :data="isTableData"
          border
          :header-cell-style="{background:'#F8F8F9'}"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
          <el-table-column label="选择" align="center" width="65">
            <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="radio"
            @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="产品名称"
            width="120">
            <template slot-scope="scope">{{ scope.row.product.name }}</template>
          </el-table-column>
          <el-table-column
            label="保司名称"
            width="120">
            <template slot-scope="scope">{{ scope.row.corp.name }}</template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="渠道名称"
            width="120">
            <template slot-scope="scope">{{ scope.row.channel.name }}</template>
          </el-table-column>
          <el-table-column
            prop="real_price"
            label="价格"
            width="120">
          </el-table-column>
          <el-table-column
            prop="title"
            label="险种方案"
            width="120">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
       
        <el-form
            style="margin-top:20px"
            :inline="true"
            :model="productMdForm"
            :rules="prMDsearchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >
          <el-form-item label="销售价格">
                               
            <el-input v-model="productMdForm.salePrice" @change="changeSalePrice" type="text" name="plate_number"></el-input>
          </el-form-item>
          <el-form-item label="生效日期">
              <el-date-picker type="date" v-model="productMdForm.add_time" placeholder="选择日期" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item label="支付凭证">
            <el-input v-model="productMdForm.plate_number" type="text" name="plate_number"></el-input>
          </el-form-item>
          <el-form-item label="投保单号">
            <el-input v-model="productMdForm.plate_number" type="text" name="plate_number"></el-input>
          </el-form-item>
          <el-form-item label="保单号">
            <el-input v-model="productMdForm.plate_number" type="text" name="plate_number"></el-input>
          </el-form-item>
          
          <el-form-item label="净费">
            <el-input v-model="productMdForm.price" disabled type="text" name="plate_number"></el-input>
          </el-form-item>
          <el-form-item label="保费">
            <el-input v-model="productMdForm.real_price" disabled type="text" name="plate_number"></el-input>
          </el-form-item>
          <el-form-item label="毛利润">
            <el-input v-model="productMdForm.profit"  type="text" name="plate_number"></el-input>
          </el-form-item>
          <el-form-item label="绩效">
            <el-input v-model="productMdForm.commission"  type="text" name="plate_number"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="success" @click="productMdFormSubmit()">确认</el-button>
    </el-dialog>
    <el-dialog title="生效日期" :visible.sync="effectiveDateDialog" width="70%">
        <!-- <el-form
            :inline="true"
            :model="addForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >
          <el-form-item label="生效日期">
              <el-date-picker type="date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-form> -->
    </el-dialog>
    <!-- 支付凭证弹框 -->
    <el-dialog title="支付凭证识别" :visible.sync="payOrderDialog" width="70%">
      <el-card class="box-card">
        <!-- 搜索  新增-->
        <el-form
            :inline="true"
            :model="payForm"
            :rules="payRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >
          <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="类型">
                  <el-select
                    v-model="payForm.status"
                    placeholder="请选择类型"
                  >
                    <el-option label="对公" :value="0"></el-option>
                    <el-option label="净费" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                  <el-form-item label="付款账号">
                    <el-input v-model="payForm.plate_number" type="text" name="plate_number"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="收款人账号">
                  <el-input v-model="payForm.vin" type="text" name="vin"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="付款人">
                  <el-input v-model="payForm.vin" type="text" name="vin"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                  <el-form-item label="收款人">
                    <el-input v-model="payForm.plate_number" type="text" name="plate_number"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="凭证流水号">
                  <el-input v-model="payForm.vin" type="text" name="vin"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="凭凭证金额">
                  <el-input v-model="payForm.vin" type="text" name="vin"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="佣金">
                  <el-input v-model="payForm.vin" type="text" name="vin"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="备注">
                  <el-input v-model="payForm.vin" type="text" name="vin"></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
                <el-button type="primary">保存</el-button>
              </el-col>
          </el-row>

        </el-form>
      </el-card>
         <!-- 表格 -->
         <e-table :tableHeadConfig="payOrderTable" :tableLoadData="payOrderTableData" style="margin-top:20px">
          <!-- <template v-slot:productName="slotData">
            <span class="table_name" @click="handelDetail(slotData)">{{slotData.data.row.product.name}}</span>
          </template> -->
          <template v-slot:productNameOne="slotData">
              <span @click="handelDetail(slotData)">{{slotData.data.row.product.name}}</span>
          </template>
          
           <template v-slot:status="slotData">
            <span>{{slotData.data.row.status | statusFilter}}</span>
          </template>
          <template v-slot:operation="slotData">
            <el-button type="warning" size="mini" @click="handelEdit(slotData)"> 编辑{{slotData.data.row.level}}</el-button>
            <!-- <el-button type="danger" size="mini"> 删除{{slotData.data.row.level}}</el-button> -->
          </template>
        </e-table>  
    </el-dialog>
    
  </div>
</template>
 
<script>
export default {
  components: {
    
  },
  data() {
    return {
      tableData: [],
      checkedDetail: [],
      showEdit: [], // 控制显示及隐藏


      isTableSearchForm: {
        productName: '',
        corpName: ''
      },
      isTableSearchRules: {},
      
      productMdForm: {
        salePrice: 0, // 销售价格
        profit: 0,    // 毛利润
        commission:0,// 绩效
        price:0,
        real_price: 0
      },

      page:1,// 当前页码
      limit:10,// 每页大小
      total:0,//总条目数

      insuranceSchemeDialog: false,
      isTableData: [],
  
      prMDsearchRules: {},
      // 生效日期
      effectiveDateDialog: false,
      // 支付凭证
      payOrderDialog: false,
      payForm: {
        plate_number: '',
        vin: ''
      },
      payRules: {},
      payOrderTableData: [],
      // 表头 ---支付凭证
      payOrderTable: [
        {
          label: "对公/净费",
          field: "credit_code"
        },
        {
          label: "佣金",
          field: ""
        },
        {
          label: "账号",
          field: "address"
        },
        {
          label: "账号名称",
          field: "name"
        },
        {
          label: "凭证流水号",
          field: "add_time"
        },
        {
          label: "凭证金额",
          field: ""
        },
        {
          label: "添加时间",
          field: ""
        }
      ],
      searchRules: [],
      pageNum: 1,
      pageSize: 15,

      productMd: '',


      editIndex:0,

      ProductRadio: '',
      radio: '',

      // rowlistPush: {
      //   sellprice: 0, // 销售价格
      //   profit: 0,    // 毛利润
      //   commission:0,// 绩效
      //   price:0,
      //   real_price: 0
      // }
      goodsList: [],

    }
  },
  created() {
    this.insuranceProduct()
  },
  methods: {
    handleSelectionChange() {},
    // // 险种方案信息

    insuranceProduct() {
      const param = {
        id: this.id,
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        pageNum: this.page,
        pageSize: this.limit,
      }
      this.$axios.insuranceProductMdList(param).then(res=>{
          if(res.code == 200){
            this.isTableData = res.data.data
            //console.log(this.isTableData[0],777);
            this.total = res.data.total
          }else{
            this.$message.error(res.msg);
          }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 险种方案的选择弹窗搜索
    isSearchSubmit() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        queryParams: this.isTableSearchForm.productName,
        page: this.page,
        limit: this.limit,
      }
      //console.log(78,param);
      this.$refs.isSearchForRef.validate((valid) => {
        if (valid) {
          this.$axios.insuranceProductMdList(param).then(res=>{
            if(res.code == 200){
              this.isTableData = res.data.data
              // this.total = res.data.total
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error =>{
              //console.log(error);
          })
        }
      })
    },
    // 险种方案
    handInsuranceScheme(e) {
      //console.log(e);
      this.insuranceSchemeDialog = true
      this.editIndex= e.data.row;

    },
    // 产品方案赋值
    handelProductMd(e) {
      //console.log(111,e.data.row);
      
      this.productMd = e.data.row
      this.tableData[this.editIndex].productMd = e.data.row.title
      this.editIndex= e.data.row;
      this.insuranceSchemeDialog = false
    },
    // 单选选择切换数据
    getCurrentRow(row){
      this.productMdForm.price= row.price;
      this.productMdForm.sellprice= row.sell_price;
      this.productMdForm.real_price= row.real_price;

      this.productMdForm.salePrice = 0;
      this.productMdForm.profit = 0;
      this.productMdForm.commission = 0;
    },
    // 点击销售价格获取值
    changeSalePrice(e) {
      this.productMdForm.profit = parseInt(parseFloat(e) - parseInt(this.productMdForm.price)) // 毛利润
      this.productMdForm.commission = parseInt(parseFloat(e) - parseInt(this.productMdForm.price))*0.23 //绩效
    },
    // 险种方案选择确认数据
    productMdFormSubmit() {
       
       this.goodsList.push(this.productMdForm);
      
      this.insuranceSchemeDialog = false

      // this.$refs.prMDsearchRules.validate((valid) => {
      //   if (valid) {
      //     this.$axios.insuranceProductMdList(param).then(res=>{
      //       if(res.code == 200){
      //         this.isTableData = res.data.data
      //         // this.total = res.data.total
      //       }
      //     }).catch(error =>{
      //         //console.log(error);
      //     })
      //   }
      // })
    },
    // 表格的新增
    rowClassName({ row, rowIndex }) {
      row.xh = rowIndex + 1
    },
    // 单选框选中数据
    handleDetailSelectionChange(selection) {
      this.checkedDetail = selection

      //console.log(selection,999);
    },
    // 点击新增更多
    handleAddBtn() {
      this.insuranceSchemeDialog = true

      const obj = {}
      obj.productMd = '测试111'
      
      // obj.salePrice = this.rowlistPush.salePrice,

      // //console.log(this.rowlistPush.salePrice,2222222);
      // obj.price = this.rowlistPush.price,
      // obj.real_price = this.rowlistPush.real_price,
      // obj.profit = this.rowlistPush.profit,
      // obj.commission = this.rowlistPush.commission,
      
      obj.mescode = '测试'
      obj.password = '123'
      this.tableData.push(obj)
    },
    // 删除
    handleDeleteBtn() {
      if (this.checkedDetail.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {
          confirmButtonText: '确定'
        })
      } else {
        this.$confirm('请是否确认删除该属性?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          callback: (action) => {
            if (action === 'confirm') {
              const val = this.checkedDetail
              val.forEach((val, index) => {
                this.tableData.forEach((v, i) => {
                  if (val.xh === v.xh) {
                    this.tableData.splice(i, 1)
                  }
                })
              })
              this.$message({
                message: '删除成功，记得保存修改喔！',
                type: 'success'
              })
              this.$refs.tb.clearSelection()
              return
            } else {
              this.$message({
                message: '已取消删除操作',
                type: 'warning'
              })
              return
            }
          }
        })
      }
    },
    // 点击修改
    showUpdate(index, row) {
      //console.log('index')
      this.showEdit[index] = true
      this.$set(this.showEdit, index, true) // 这里要用$set方法，否则页面状态不更新
    },
    // 取消修改
    cancelUpdate(index) {
      this.$confirm('取消修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$set(this.showEdit, index, false)
        })
        .catch(() => {})
    },
    // 提交修改
    submit(index, row) {
      // 发送请求，隐藏输入框
      this.$message({
        type: 'success',
        message: '已缓存，记得点击保存提交修改喔！',
        duration: 888,
        onClose: () => {
          this.$set(this.showEdit, index, false) // vue添加属性的方法
        }
      })
    },

    // 生效日期
    handEffectiveDate(e) {
      //console.log(e);
      this.effectiveDateDialog = true
    },
    // 支付凭证
    handPayOrder(e) {
      //console.log(e);
      this.payOrderDialog = true

    }
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/view/order/orderTable.vue